// extracted by mini-css-extract-plugin
module.exports = {"Primary":"#e11e73","Whitee":"#FFFFFF","Danger":"#dc3545","Warning":"#ffc107","Dark":"#121212"};